import { COVER_AND_REPORT_LAYOUT, QC_LAYOUT, SUMMARY_LAYOUT, REPORT_ONLY_LAYOUT } from '../../constants/reportLayouts';
import { API_ENPOINTS } from '../../constants/api';

const isHttpUrl = require('is-http-url');

export const deserializeCompany = ({
  id,
  name,
  customerNumber,
  enabled = true,
  logoBase64,
  email,
  admins,
  contactInfo,
  subscription,
  rentalCustomer,
  rentalUnits,
  purchasedUnits,
  testsInCurrentMonth,
  testsInPreviousMonth,
  url,
  isIsn,
  isnDomain,
  isnKey,
} = {}) => {
  contactInfo = contactInfo || {};
  admins = admins || [];

  const address = contactInfo.address || {};
  const companyUrl = urlCutProtocol(url);

  return {
    id,
    name,
    customerNumber,
    enabled,
    logoBase64,
    admins,
    subscription,
    rentalCustomer,
    rentalUnits,
    purchasedUnits,
    email,
    testsInCurrentMonth,
    testsInPreviousMonth,
    companyUrl,
    fax: contactInfo.fax,
    phone: contactInfo.phone,
    address1: address.address1,
    address2: address.address2,
    city: address.city,
    country: address.country,
    county: address.county,
    postalCode: address.postalCode,
    state: address.state,
    isIsn,
    isnDomain,
    isnKey,
  };
};

export const serializeCompany = (company = {}) => {
  company.companyUrl = addProtocol(company.companyUrl);
  return {
    name: company.name,
    customerNumber: company.customerNumber,
    subscription: company.subscription,
    rentalUnits: Number(company.rentalUnits),
    purchasedUnits: Number(company.purchasedUnits),
    rentalCustomer: company.rentalCustomer,
    email: company.email,
    url: company.companyUrl || null,
    contactInfo: {
      fax: company.fax,
      phone: company.phone,
      address: {
        address1: company.address1,
        address2: company.address2,
        city: company.city,
        state: company.state,
        postalCode: company.postalCode,
        country: company.country,
        county: company.county,
      },
    },
    isIsn: company.isIsn,
    isnDomain: company.isnDomain,
    isnKey: company.isnKey,
  };
};

function urlValidateProtocol(url) {
  url = url || '';
  return isHttpUrl(url);
}

function urlCutProtocol(url) {
  if (url && urlValidateProtocol(url)) {
    return (url = url.replace(/^(https?:|)\/\//, ''));
  }
  return url;
}

function addProtocol(url) {
  if (!urlValidateProtocol(url) && url) {
    return 'https://' + url;
  }
  return url;
}

export const deserializeReportOptions = (response) => {
  const {
    chartReferenceLine,
    customLabel,
    customLevel,
    defaultLayout,
    layoutTemplateId,
    high,
    low,
    template,
    coverLetter,
    includeCoverLetter,
    attachmentFilename,
    contentSettings,
    interpretRadonTestResult,
    retestingGuidelines,
    endOfReport,
    includeUncertaintyCalculation,
  } = response;

  const layouts = response.layouts || [];

  return {
    chartReferenceLine,
    customLabel,
    customLevel,
    defaultLayout,
    layoutTemplateId,
    high: high && high.toFixed(1),
    low: low && low.toFixed(1),
    template,
    coverLetter,
    includeCoverLetter,
    hasAttachment: !!attachmentFilename,
    attachmentFilename,
    contentSettings,
    interpretRadonTestResult,
    retestingGuidelines,
    endOfReport,
    includeUncertaintyCalculation,
    layouts: {
      [COVER_AND_REPORT_LAYOUT]: layouts.find(({ layout }) => layout === COVER_AND_REPORT_LAYOUT),
      [QC_LAYOUT]: layouts.find(({ layout }) => layout === QC_LAYOUT),
      [SUMMARY_LAYOUT]: layouts.find(({ layout }) => layout === SUMMARY_LAYOUT),
      [REPORT_ONLY_LAYOUT]: layouts.find(({ layout }) => layout === REPORT_ONLY_LAYOUT),
    },
  };
};

export const deserializeEmailTemplate = (response, companyId, reportType) => {
  const attachments = [
    {
      index: 1,
      exists: response.hasAttachment1,
      name: response.attachment1Filename,
    },
    {
      index: 2,
      exists: response.hasAttachment2,
      name: response.attachment2Filename,
    },
    {
      index: 3,
      exists: response.hasAttachment3,
      name: response.attachment3Filename,
    },
  ];

  return {
    fromEmail: response.from,
    subject: response.subject,
    body: response.body,
    attachments: attachments
      .filter(({ exists }) => exists)
      .map(({ index, name }) => buildAttachmentInfo(index, name, companyId, reportType)),
  };
};

function buildAttachmentInfo(index, name, companyId, reportType) {
  const link = `${API_ENPOINTS.companyManagement}/${companyId}/emailTemplates/${reportType}/attachment/${index}`;
  return {
    name,
    link,
    uploaded: true,
    deleted: false,
  };
}



// WEBPACK FOOTER //
// src/actions/companies/serializers.js